import React from 'react';
import Table from 'react-bootstrap/Table';

const AwardsTable = ({ data }) => {
  const dancer = data?.dancer || '';
  const rows = Array.isArray(data?.results) ? data.results : [];

  return (
    <div>
      <h4 className="mb-3">Dancer: {dancer || '-'}</h4>

      <Table responsive striped>
        <thead>
          <tr>
            <th>Competition Name</th>
            <th>Placed</th>
            <th>Rank</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((row, idx) => {
              const {
                competitionName = '',
                placed = false,
                rank = '',
                hasResults = true
              } = row || {};

              return (
                <tr key={idx}>
                  <td>{competitionName}</td>
                  {hasResults ? (
                    <>
                      <td>
                        <input
                          type="checkbox"
                          checked={!!placed}
                          readOnly
                          aria-readonly="true"
                        />
                      </td>
                      <td>{rank ?? ''}</td>
                    </>
                  ) : (
                    <td colSpan={2}>No Results</td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>No data</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AwardsTable;
